import React from "react";

export default function RefundPolicy() {
  // const sections = [
  //   {
  //     title: "1. Refund Eligibility",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>Wrong cancellation fee charged after valid evidence.</li>
  //         <li>Amount deducted but booking did not get confirmed.</li>
  //         <li>Failed payment or double charge due to technical error.</li>
  //         <li>Excess fare charged due to a proven app/system issue.</li>
  //         <li>Refund eligible after investigation of insurance-related deductions (where applicable).</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "2. Non-Refundable Transactions",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>No refund for valid cancellation fee deductions.</li>
  //         <li>No refund for fare disagreements without valid GPS proof.</li>
  //         <li>No refund for delays caused by traffic, weather, checkpoints, or vehicle breakdowns.</li>
  //         <li>No refund if Customer refuses helmet/seat belt where required by law.</li>
  //         <li>No refund if Rider/Customer mistake leads to trip cancellation without valid reason.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "3. Payment Dispute Investigation",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>Users must raise disputes within 3 days of the transaction through app support or email.</li>
  //         <li>Users must provide Transaction ID, Ride ID, screenshots, or explanation of issue.</li>
  //         <li>INRYDE verifies disputes using system logs, GPS routes, wait-time records, and fraud checks.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "4. Refund Processing Time",
  //     content: (
  //       <table
  //         style={{
  //           width: "100%",
  //           borderCollapse: "collapse",
  //           marginTop: "10px",
  //           color: "#6C757D",
  //         }}
  //       >
  //         <thead>
  //           <tr style={{ backgroundColor: "#F8F9FA" }}>
  //             <th style={{ padding: "10px", border: "1px solid #ddd" }}>Payment Mode</th>
  //             <th style={{ padding: "10px", border: "1px solid #ddd" }}>Processing Time</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           <tr>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>UPI / Wallet</td>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>2–5 Business Days</td>
  //           </tr>
  //           <tr>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>Net Banking / Cards</td>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>5–7 Business Days</td>
  //           </tr>
  //           <tr>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>Payment Gateway Delays</td>
  //             <td style={{ padding: "10px", border: "1px solid #ddd" }}>Subject to bank/network</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  //   {
  //     title: "5. Security, Chargebacks & Fraud",
  //     content:
  //       "Fake refund claims, chargeback misuse, or fraudulent complaints may lead to account suspension or legal recovery. INRYDE may withhold or reverse refunds if fraud is suspected.",
  //   },
  //   {
  //     title: "6. Refund Mode",
  //     content:
  //       "Refunds are always credited back to the original payment method only. Wallet refunds cannot be transferred to bank accounts unless legally required.",
  //   },
  //   {
  //     title: "7. Contact Support",
  //     content: (
  //       <p style={{ color: "#6C757D" }}>
  //         Email:{" "}
  //         <a
  //           href="mailto:support@inryde.in"
  //           style={{ color: "#E63946", textDecoration: "underline" }}
  //         >
  //           support@inryde.in
  //         </a>
  //         <br />
  //         Phone: <strong>9866398548</strong>
  //         <br />
  //         Office: 2nd floor, D.no 50-1-40, Near ASR Statue, Seethammadhara, Visakhapatnam – 530013
  //       </p>
  //     ),
  //   },
  // ];

  const sections = [
  {
    title: "1. Refund Policy",
    content: (
      <ul style={{ color: '#6C757D', paddingLeft: '20px' }}>
        <li>Refund or replacement is allowed if the customer proves that the delivered product quality is unsatisfactory.</li>
        <li>Refund requests for damaged or defective items will be processed only after the merchant verifies the claim.</li>
        <li>Incorrect or mismatched product claims must be reported within 7 days of delivery for eligibility.</li>
        <li>For products with manufacturer warranty, refund requests must be directed to the respective manufacturer.</li>
        <li>Once approved, refunds will be processed within 1–2 business days to the customer.</li>
      </ul>
    ),
  },
];


  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "50px",
          textAlign: "center",
        }}
      >
        Refund Policy
      </h1>

      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#E63946",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          {section.content}
        </div>
      ))}
    </div>
  );
}
